import React from "react";
import tw from "twin.macro";
import OrgChartSvg from "./orgchart.inline.svg";
import OrgChartSvgSm from "./orgchart-sm.inline.svg";

const ChartContainer = tw.div`container mx-auto`;
const ChartImgC = tw.div`w-full max-w-5xl h-full object-contain px-4 lg:px-0 lg:w-10/12 mx-auto block my-8`;
const SmallSize = tw.div`md:hidden`;
const LargeSize = tw.div`hidden md:block`;

const OrgChart = () => (
  <ChartContainer>
    <ChartImgC>
      <LargeSize>
      <OrgChartSvg/>
      </LargeSize>
      <SmallSize>
      <OrgChartSvgSm/>
      </SmallSize>
    </ChartImgC>
  </ChartContainer>
);

export default OrgChart;
